module.exports = __webpack_public_path__ + "static/media/count50_118.3d7dbdd9.png";